<div [formGroup]="formGroup" class="w-full">
  <mat-form-field appearance="outline" floatLabel="always" class="w-full">
    <mat-label class="font-poppins">{{ label }}</mat-label>
    <input class="truncate" type="text" [placeholder]="placeholder" aria-label="Origen" matInput
      [formControlName]="controlName" (focus)="handleFocus()" (blur)="handleBlur()" [matAutocomplete]="auto1" />
    @if (showHint()) {
    <mat-hint class="text-primary-400">
      Ingresar al menos {{ charsMin }} letras
    </mat-hint>
    }
    @if (value && !isLoading) {
    <div
      class="flex flex-row justify-center items-center rounded-full  bg-neutral-100 cursor-pointer top-[38%] w-[16px] h-[16px] -right-[4%] absolute transition-all hover:bg-neutral-300"
      (click)="clearValue()">
      <span class="material-symbols-outlined close text-secondary-600"> close </span>
    </div>
    }
    @if (isLoading) {
    <mat-spinner strokeWidth="2" color="warn" [diameter]="20" matSuffix class="!h-4 !w-4 !mr-3" />
    }
    <mat-autocomplete autoActiveFirstOption #auto1="matAutocomplete" [displayWith]="displayFn">
      @for (option of options; track option) {
      <mat-option class="!text-2xs !text-primary-800 font-poppins" [value]="option">
        <span [innerHTML]="highlightFn(option.name, value)"></span>
      </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
</div>